const navMenu = [
    {
        route: 'wellfulHome'
    },
    {
        route: 'register'
    },
    // {
    //     route: 'purchase'
    // },
    {
        route: 'userList'
    },
    {
        route: 'couponList'
    },
    {
        route: 'productList'
    },
    {
        route: 'authorList'
    },
    {
        route: 'genreList'
    },
    {
        route: 'players-list'
    }
]

export default navMenu
